export default "__VITE_ASSET__DnqtL41v__"